import { useSearchParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Base, toast } from '@itsrever/design-system'
import { useEcommerceFilter } from '@/hooks/use-selected-ecommerce-ids'
import { useExportProcessesCsv } from '@/hooks/use-export-processes-csv'
import posthog from 'posthog-js'
import { processesRequestFrom } from '@/domain/processes/list-request'

const { Button } = Base

export const ExportProcessesButton = () => {
  const { t } = useTranslation()

  const ecommerceId = useEcommerceFilter()

  const [searchParams] = useSearchParams()

  const { mutate, isPending } = useExportProcessesCsv()

  const exportCSV = () => {
    const filters = processesRequestFrom(searchParams, {
      ecommerceId,
      freetext: searchParams.get('search') ?? undefined
    })

    mutate(filters, {
      onSuccess: (data) => {
        const link = document.createElement('a')
        link.href = data.download_url as string
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        toast({
          text: t('orders.export_csv_success'),
          variant: 'success'
        })
      },
      onError: () => {
        toast({
          text: t('orders.error_csv_error'),
          variant: 'error'
        })
      }
    })
    posthog?.capture('Export-CSV button clicked')
  }

  return (
    <Button onClick={exportCSV} variant="primary" loading={isPending}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.75002 2.50225V2.5H15.9985C16.4125 2.5 16.75 2.84125 16.75 3.244V16.756C16.7498 16.9534 16.6713 17.1426 16.5316 17.2821C16.392 17.4216 16.2027 17.5 16.0053 17.5H3.99477C3.89628 17.4993 3.79888 17.4792 3.70815 17.4409C3.61742 17.4026 3.53513 17.3468 3.46597 17.2766C3.39681 17.2065 3.34215 17.1234 3.30509 17.0322C3.26804 16.9409 3.24933 16.8432 3.25002 16.7448V7L7.75002 2.50225ZM5.37252 7H7.75002V4.6225L5.37252 7ZM9.25002 4V7.75C9.25002 7.94891 9.171 8.13968 9.03035 8.28033C8.8897 8.42098 8.69893 8.5 8.50002 8.5H4.75002V16H15.25V4H9.25002Z"
          fill="white"
        />
      </svg>
      {t('orders.export_csv')}
    </Button>
  )
}
